import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { useCompany } from 'features/company/CompanyContext';
import { Card, HeroBand, StatusChip } from 'shared/components/Feedback';
import { PageMeta } from 'shared/components/PageMeta';
import { formatNumber } from 'shared/utilities/format';

function StatCard({ label, value, to }) {
  const content = (
    <Card className="stat-card">
      <p className="kicker">{label}</p>
      <p className="stat-value">{value}</p>
    </Card>
  );
  return to ? <Link className="stat-card-link" to={to}>{content}</Link> : content;
}

export function CompanyDashboardPage() {
  const { t } = useI18n();
  const { company, dashboard } = useCompany();
  const credits = dashboard.credits || {};
  const stats = dashboard.stats || {};

  return (
    <div className="company-dashboard">
      <PageMeta titleKey="meta.companyDashboard" />
      <HeroBand
        kicker={t('company.dashboard.kicker')}
        title={company?.display_name || company?.legal_name}
        body={t('company.dashboard.body')}
      />
      <div className="stat-grid">
        <StatCard label={t('company.dashboard.activePlans')} value={formatNumber(stats.active_plans || 0, 'en')} to={paths.companyCredits} />
        <StatCard label={t('company.dashboard.totalCredits')} value={formatNumber(credits.total_credits ?? 0, 'en')} to={paths.companyCredits} />
        <StatCard label={t('company.dashboard.availableCredits')} value={formatNumber(credits.available_credits ?? 0, 'en')} to={paths.companyCredits} />
        <StatCard label={t('company.dashboard.activeCodes')} value={formatNumber(stats.active_codes || 0, 'en')} to={paths.companyCodes} />
        <StatCard label={t('company.dashboard.claimedCodes')} value={formatNumber(stats.claimed_codes || 0, 'en')} to={paths.companyCodes} />
        <StatCard label={t('company.dashboard.completedAssessments')} value={formatNumber(stats.completed_assessments || 0, 'en')} to={paths.companyParticipants} />
      </div>
      <Card>
        <h2>{t('company.dashboard.recentParticipants')}</h2>
        {(dashboard.recent_participants || []).length === 0 ? (
          <p className="muted">{t('company.participants.empty')}</p>
        ) : (
          <div className="record-table">
            {(dashboard.recent_participants || []).map((participant) => (
              <article key={participant.attempt_id || participant.id} className="record-row">
                <div>
                  <strong>{participant.full_name}</strong>
                  <StatusChip>{participant.attempt_status_label || participant.attempt_status}</StatusChip>
                </div>
                <p className="muted">{participant.code_masked}</p>
                {participant.attempt_status === 'completed' ? (
                  <Link className="btn btn-secondary" to={paths.companyParticipantResult(participant.attempt_id)}>
                    {t('actions.viewResult')}
                  </Link>
                ) : <span />}
              </article>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
